<div *ngIf="fliData != null">
    <table mat-table [dataSource]="accounts">
        <ng-container matColumnDef="text">
            <th
                mat-header-cell
                *matHeaderCellDef
                class="textCell"
                stylePreference
                [textColor]="tableHeaderColor"
                backgroundColor="white"
            >
                <div>
                    <span *ngIf="currentFliIndex !== mockedIndex && currentAccordionIndex !== mockedIndex"
                        >{{ currentAccordionIndex }}.{{ currentFliIndex }} {{ fliData.name }}</span
                    >
                </div>
            </th>
            <td mat-cell *matCellDef="let row" stylePreference [textColor]="textColor" backgroundColor="white">
                <div>
                    <span>{{ row.text }}</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container *ngIf="showPreviousData" matColumnDef="openValue">
            <th
                mat-header-cell
                *matHeaderCellDef
                stylePreference
                [textColor]="tableHeaderColor"
                [backgroundColor]="backgroundColor"
            >
                <div>
                    <span>{{ openDate | dateLocale }}</span>
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let row"
                stylePreference
                [textColor]="textColor"
                [backgroundColor]="backgroundColor"
            >
                <div>
                    <span> {{ row.openValue | finNumber : numberFormat }}</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="column1">
            <th
                mat-header-cell
                *matHeaderCellDef
                stylePreference
                [textColor]="tableHeaderColor"
                backgroundColor="white"
            >
                <div>
                    <span> {{ fliData.headers.column1[availableCurrentLanguage] }}</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let row" stylePreference [textColor]="textColor" backgroundColor="white">
                <div>
                    <span> {{ row.column1 != null ? (row.column1 | finNumber : numberFormat) : '' }}</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="column2">
            <th
                mat-header-cell
                *matHeaderCellDef
                stylePreference
                [textColor]="tableHeaderColor"
                backgroundColor="white"
            >
                <div>
                    <span>{{ fliData.headers.column2[availableCurrentLanguage] }}</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let row" stylePreference [textColor]="textColor" backgroundColor="white">
                <div>
                    <span> {{ row.column2 != null ? (row.column2 | finNumber : numberFormat) : '' }}</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="column3">
            <th
                mat-header-cell
                *matHeaderCellDef
                stylePreference
                [textColor]="tableHeaderColor"
                backgroundColor="white"
            >
                <div>
                    <span> {{ fliData.headers.column3[availableCurrentLanguage] }}</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let row" stylePreference [textColor]="textColor" backgroundColor="white">
                <div>
                    <span> {{ row.column3 != null ? (row.column3 | finNumber : numberFormat) : '' }}</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="column4">
            <th
                mat-header-cell
                *matHeaderCellDef
                stylePreference
                [textColor]="tableHeaderColor"
                backgroundColor="white"
            >
                <div>
                    <span>{{ fliData.headers.column4[availableCurrentLanguage] }}</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let row" stylePreference [textColor]="textColor" backgroundColor="white">
                <div>
                    <span> {{ row.column4 != null ? (row.column4 | finNumber : numberFormat) : '' }}</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="closeValue">
            <th
                mat-header-cell
                *matHeaderCellDef
                stylePreference
                [textColor]="tableHeaderColor"
                [backgroundColor]="backgroundColor"
            >
                <div [ngClass]="{ 'no-previous': !showPreviousData }">
                    <span>{{ closeDate | dateLocale }}</span>
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let row"
                stylePreference
                [textColor]="textColor"
                [backgroundColor]="backgroundColor"
            >
                <div [ngClass]="{ 'no-previous': !showPreviousData }">
                    <span>{{ row.closeValue | finNumber : numberFormat }}</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="{{ row.className }}"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
</div>
